<template>
    <router-view/>
</template>

<script>
export default {
    name: "ReadOnlyView",
};
</script>

<style scoped lang="scss">

</style>
